<template>
    <div class="event-view">
        <p v-if="ajax.loading">Loading...</p>
        <one-event
            v-else-if="!!event"
            :event="event"
        />
        <p v-else>Event not found.</p>
    </div>
</template>

<script>
import axios from 'axios';
import OneEvent from './OneEvent';

export default {
    components: {
        OneEvent,
    },

    data: function () {
        return {
            event: null,

            ajax: {
                loading: true,
                message: '',
            }
        }
    },

    methods: {
        loadData() {
            this.ajax.loading = true;

            const pathParts = window.location.pathname.split('/');
            const slug = pathParts.pop();

            return axios.get(process.env.MIX_API_BASE_URL + '/api/front/events/' + slug)
                .then(response => {
                    this.event = Object.assign({}, response.data);
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.ajax.loading = false;
                })
            ;
        },
    },

    created() {
        this.loadData();
    },
}
</script>

<style lang="scss">
</style>
